/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./implement-way.vue?vue&type=template&id=74b4f044&"
import script from "./implement-way.vue?vue&type=script&lang=js&"
export * from "./implement-way.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports